import { createSelector } from 'reselect';
import type { RootState } from '../../../store/types';

export const getReferrals = (state: RootState) => state.referrals;

export const getShouldShowReferralsTab = createSelector(getReferrals, (referrals) => {
  const { referrals: { isDriverEligible = false } = {} } = referrals;
  return Boolean(isDriverEligible);
});
